import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  dialogOptions: { type: 'panel' },
  formLayout: 'pickup',
  storesLayout: 'bopis'
} satisfies RecursivePartial<DialogConfig['pickupInStore']>
